module.exports = __webpack_public_path__ + "f8c3087d8fc49534e85cd8dc76a33ab8.svg";